module.exports = __webpack_public_path__ + "static/img/Miaoli_01.ff992ec9.jpg";